import React, {Component} from 'react';
import {Row, Col, Card, CardBody} from 'reactstrap';

import TopicEdit from './TopicEditComponent';
import BreadCrumbData from '../breadcrumbs/EditTopicBreadcrumb'


import axios from 'axios';
import {serverPath} from '../common';

class TopicEditPage extends Component
{
	constructor(props)
	{
		super(props);
		this.state =
			{
				breadCrumbData:
				{
					userPrefix: 'p',
					courseId: 0,
					courseName: '',
					topicName: '',
					topicId: props.match.params.topicId
				},
				topicData:{},
				topicProblems:[]
			};

		this.onFinish = this.onFinish.bind(this);
		this.onNameChange = this.onNameChange.bind(this);
	}

	componentDidMount()
	{
		getTopicData(this.props.match.params.topicId)
			.then((response)=>
			{
				this.setState(
					{
						topicData:
							{
								...response.data.topicData,
								type:response.data.type
							},
						...setBreadCrumbData(this.state.breadCrumbData,
							{
								...setBreadCrumbCourseId(this.state.breadCrumbData,
									response.data.topicData.idCourse),
								...setBreadCrumbCourseName(this.state.breadCrumbData,
									response.data.topicData.courseName)
							}),
						topicProblems:response.data.topicProblems
					});
			});
	}

	onFinish(arr)
	{
		this.props.history.goBack();
		setTimeout(()=>window.location.reload(), 20);
	}

	onNameChange(name)
	{
		this.setState(
			setBreadCrumbData(this.state.breadCrumbData,
				setBreadCrumbTopicName(this.state.breadCrumbData, name)
			)
		);
	}

	render()
	{
		return (
			<React.Fragment>
				<Row>
					<Col>
						<BreadCrumbData data={this.state.breadCrumbData}/>
					</Col>
				</Row>
				<Row className='justify-content-center'>
					<Col>
						<Card>
							<CardBody>
								<TopicEdit  topicData={this.state.topicData}
											topicProblems={this.state.topicProblems}
											topicId={this.props.match.params.topicId}
											onFinish={this.onFinish}
											onNameChange={this.onNameChange}
								/>
							</CardBody>
						</Card>
					</Col>
				</Row>
			</React.Fragment>
		);
	}

}

/*Presenter Code*/
function setBreadCrumbData(bcd, data)
{
	return (
		{
			breadCrumbData:
			{
				...bcd,
				...data
			}
		});
}

function setBreadCrumbTopicName(bcd, name)
{
	return {topicName:name};
}

function setBreadCrumbCourseName(bcd, name)
{
	return {courseName:name};
}

function setBreadCrumbCourseId(bcd, id)
{
	return {courseId:id};
}


/*Helpers*/
function getTopicData(topicId)
{
	return 	axios.get(`${serverPath}/professorService.php`,
		{
			params:
				{
					action:'getTopicEditData',
					topicId:topicId
				}
		});
}
export default TopicEditPage;